jQuery(document).ready(function ($) {
    $('.hero__scroll').on('click', function (event) {
        event.preventDefault();

        const next_section = $(this).closest('.hero').next();

        let offset = next_section.offset().top - $('.site-header').outerHeight();

        if ($('#wpadminbar').length > 0) {
            offset -= $('#wpadminbar').outerHeight();
        }

        $('body, html').animate({
            scrollTop: offset
        }, 1000);
    });
});